import React from "react";
import { Grid, Typography, Paper, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import GenricButton from "../Custom/GenericButton";

const OrderCard = ({ order, onViewDetails, customButtons }) => {
  console.log(order);
  const { t } = useTranslation();

  const getStatusColor = (status) => {
    if (status === "DELIVERED") return "success";
    if (status === "CANCELLED") return "error";
    if (status === "PAID") return "success";
    return order.is_paid ? "success" : "error";
  };

  const getOrderNameLabel = () =>
    order.order_type === "FARMER" ? t("Farmer Name") : t("Institution Name");

  const getOrderNameValue = () =>
    order.order_type === "FARMER" ? order.farmer_name : order.institution_name;

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 2,
        marginTop: 2,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
      }}
    >
      <Grid container spacing={1}>
        {[
          {
            label: getOrderNameLabel(),
            value: getOrderNameValue(),
          },
          { label: t("Order Id"), value: order.id },
          {
            label: t("Order Quantity"),
            value: `${order.requested_quantity} kg`,
          },
          {
            label: t("Order Amount"),
            value: `Rs. ${order.total_amount_payable}`,
          },
        ].map((item) => (
          <React.Fragment key={item.label}>
            <Grid item xs={6}>
              <Typography variant="body2" fontWeight="bold">
                {t(item.label)}:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">{item.value}</Typography>
            </Grid>
          </React.Fragment>
        ))}

        <Grid item xs={6}>
          <Typography variant="body2" fontWeight="bold">
            {t("order status")}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Chip
            label={order.order_status}
            color={getStatusColor(order.order_status)}
            size="small"
          />
        </Grid>

        <Grid item xs={12} sx={{ marginTop: 1 }}>
          {customButtons ? (
            <>
              {customButtons.map((button, index) => (
                <GenricButton
                  key={index}
                  backgroundColor={
                    button.color === "primary"
                      ? "primary"
                      : button.color === "info"
                      ? "#2196f3"
                      : "#F7A419"
                  }
                  fontColor="#fff"
                  fontSize="12px"
                  padding="5px 10px"
                  style={{ marginRight: "8px", marginBottom: "8px" }}
                  onClick={button.onClick}
                >
                  {t(button.label)}
                </GenricButton>
              ))}
            </>
          ) : null}
          <GenricButton
            backgroundColor="primary"
            fontColor="#fff"
            fontSize="12px"
            padding="5px 10px"
            style={{ marginRight: "8px", marginBottom: "8px" }}
            onClick={() => onViewDetails(order)}
          >
            {t("Full Details")}
          </GenricButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OrderCard;
